import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.EduSendFilters = class EduSendFilters extends Snappy.BaseComponent {
    static get tagName() {
        return 'bootroom-send-filters';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.button = $(this.$element);
        this.filters = new Map();
        this.itemName = this.button.data('itemName');
    }

    handleClick(e) {
        console.log(Array.from(e.currentTarget.attributes));
        let allAttributes = Array.from(e.currentTarget.attributes)
        allAttributes.map((attrs) => {
            if (attrs.name.includes('filter-')) {
                console.log(attrs.name + " - " + attrs.value);
                this.filters.set(attrs.name.replace('filter-', ''), attrs.value)
            }

            
        })
        localStorage.setItem(this.itemName, JSON.stringify(Array.from(this.filters)))
        console.log(localStorage.getItem(this.itemName))
    }
    
    setEventListeners() {
        this.button.on('click', this.handleClick.bind(this));
    }

    render() {
        this.setVars();
        this.setEventListeners();
    }

    
}



// WEBPACK FOOTER //
// ./components/edu-send-filters/scripts/_edu-send-filters.js